module.exports = __webpack_public_path__ + "static/media/after-Introduksjon-sprakforstaelse.d609356b.mp3";